import { Controller } from "@hotwired/stimulus"
import CodeMirror from "codemirror"
import "codemirror/mode/htmlmixed/htmlmixed.js"

export default class extends Controller {
  connect() {
    this.codeMirror = CodeMirror.fromTextArea(this.element, {
      mode: "htmlmixed",
      lineNumbers: false,
      readOnly: this.element.disabled
    });
  }

  disconnect() {
    this.codeMirror.toTextArea();
  }
}
